var _path, _path2, _path3, _rect, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 70c19.33 0 35-15.67 35-35S54.33 0 35 0 0 15.67 0 35s15.67 35 35 35z",
    fill: "url(#governance_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 31h-12v4.5h12V31z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 31.75A2.25 2.25 0 0020 34v10.5a2.25 2.25 0 002.25 2.25h25.5A2.25 2.25 0 0050 44.5V34a2.25 2.25 0 00-2.25-2.25h-25.5z",
    fill: "#6A659B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 37,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#54507C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 39V22a1.5 1.5 0 011.5-1.5h16.5a1.5 1.5 0 011.5 1.5v17",
    fill: "#A19EC5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "governance_svg__paint0_linear",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E8F3"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA3MCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zNSA3MEM1NC4zMyA3MCA3MCA1NC4zMyA3MCAzNUM3MCAxNS42NyA1NC4zMyAwIDM1IDBDMTUuNjcgMCAwIDE1LjY3IDAgMzVDMCA1NC4zMyAxNS42NyA3MCAzNSA3MFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPHBhdGggZD0iTTQwLjI1IDMxSDI4LjI1VjM1LjVINDAuMjVWMzFaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjIuMjUgMzEuNzVDMjEuMDA3NCAzMS43NSAyMCAzMi43NTc0IDIwIDM0VjQ0LjVDMjAgNDUuNzQyNiAyMS4wMDc0IDQ2Ljc1IDIyLjI1IDQ2Ljc1SDQ3Ljc1QzQ4Ljk5MjYgNDYuNzUgNTAgNDUuNzQyNiA1MCA0NC41VjM0QzUwIDMyLjc1NzQgNDguOTkyNiAzMS43NSA0Ny43NSAzMS43NUgyMi4yNVoiIGZpbGw9IiM2QTY1OUIiLz4KPHJlY3QgeD0iMjMiIHk9IjM3IiB3aWR0aD0iMjQiIGhlaWdodD0iNCIgcng9IjIiIGZpbGw9IiM1NDUwN0MiLz4KPHBhdGggZD0iTTI1LjI1IDM5TDI1LjI1IDIyQzI1LjI1IDIxLjE3MTYgMjUuOTIxNiAyMC41IDI2Ljc1IDIwLjVINDMuMjVDNDQuMDc4NCAyMC41IDQ0Ljc1IDIxLjE3MTYgNDQuNzUgMjJWMzkiIGZpbGw9IiNBMTlFQzUiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjM1IiB5MT0iMCIgeDI9IjM1IiB5Mj0iNzAiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0id2hpdGUiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRTdFOEYzIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgGovernance as ReactComponent };